'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import AttdFilter from './attdFilter';

class AttdHeader extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="atd-hd">
                <h4><b>Summary of Employee Attendance</b></h4>

                <AttdFilter />

                <div className="clear"></div>
            </div>
        );
    }
}
export default AttdHeader;


// WEBPACK FOOTER //
// ./app/components/attdComponents/attdHeader.js